var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, takeLatest, } from 'redux-saga/effects';
import { runActionAfterDelay } from '../../utils/sagas';
import { getWoosmapApiKey } from '../../utils';
import { actions as coordinatesActions } from '../coordinates/actions';
import { ActionTypes, actions } from './actions';
import { fetchLocalities, fetchLocalityDetails } from './requests';
import { getLocalitiesSearch } from './selectors';
export function loadLocalities() {
    var search, key, localitiesResponse, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                return [4 /*yield*/, select(getLocalitiesSearch)];
            case 1:
                search = _a.sent();
                return [4 /*yield*/, select(getWoosmapApiKey)];
            case 2:
                key = _a.sent();
                return [4 /*yield*/, call(fetchLocalities, search, key)];
            case 3:
                localitiesResponse = _a.sent();
                return [4 /*yield*/, put(actions.loadLocalitiesSuccess(localitiesResponse.localities))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                error_1 = _a.sent();
                return [4 /*yield*/, put(actions.loadLocalitiesFailure(error_1))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadLocalityDetails(_a) {
    var key, detailsResponse, _b, lat, lng, error_2;
    var publicId = _a.payload.publicId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 6]);
                return [4 /*yield*/, select(getWoosmapApiKey)];
            case 1:
                key = _c.sent();
                return [4 /*yield*/, call(fetchLocalityDetails, publicId, key)];
            case 2:
                detailsResponse = _c.sent();
                _b = detailsResponse.result.geometry.location, lat = _b.lat, lng = _b.lng;
                return [4 /*yield*/, put(coordinatesActions.setUserCoordinates({ lat: lat, lng: lng }))];
            case 3:
                _c.sent();
                return [3 /*break*/, 6];
            case 4:
                error_2 = _c.sent();
                return [4 /*yield*/, put(actions.loadLocalitiesFailure(error_2))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.LOAD_LOCALITIES, loadLocalities)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_LOCALITIES_FAILURE, function () {
                        return runActionAfterDelay(actions.removeLocalitiesError());
                    })];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_LOCALITY_DETAILS, loadLocalityDetails)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
